
import React, { useState, useEffect } from 'react';
import "../style/underMaintenance.css"

const UnderMaintenance = () => {
    const [dots, setDots] = useState('');
    
    // Animated loading dots
    useEffect(() => {
        const interval = setInterval(() => {
            setDots(prev => prev.length >= 3 ? '' : prev + '.');
        }, 500);
        
        return () => clearInterval(interval);
    }, []);

    return (
        <div style={{ minHeight: '100vh', overflowX: 'hidden' }}>
            <div className='maintenanceContainer'>
                <div className='maintenanceIconWrapper'>
                    <div className='maintenanceIcon'>
                        <div className='maintenanceIconInner'>
                            <img src="/images/support.png" alt="maintenance tools" />
                        </div>
                        <div className='maintenanceProgressRing'>
                            <div className='maintenanceProgressBar'></div>
                        </div>
                    </div>
                </div>
                
                <div className='maintenanceTitle'>
                    We're upgrading Arrows<span className='loadingDots'>{dots}</span>
                </div>
                
                <div className='maintenanceTextWrap'>
                    <div className='upgradeMessage'>
                        <h2>🚀 Exciting improvements in progress!</h2>
                        <p>We're enhancing your experience with:</p>
                        <ul className='upgradeList'>
                            <li>✨ Better conversations and interactions</li>
                            <li>🎯 Improved feedback and cues</li>
                            <li>⚡ Enhanced performance and stability</li>
                        </ul>
                    </div>
                    
                    <div className='estimatedTime'>
                        <div className='timeCard'>
                            <div className='timeIcon'>⏱️</div>
                            <div className='timeText'>
                                <strong>Estimated downtime:</strong> 1-3 minutes
                            </div>
                        </div>
                    </div>

                    <div className='maintenanceTextS'>
                        <div className='contactInfo'>
                            <h3>Need immediate assistance?</h3>
                            <a href="mailto:lev@ar-rows.com" className='contactLink'>
                                📧 lev@ar-rows.com
                            </a>
                        </div>
                    </div>
                </div>
                
                <div className='refreshNote'>
                    <p>This page will automatically refresh when we're back online</p>
                </div>
            </div>
        </div>
    );
};

export default UnderMaintenance;
